export default "__VITE_ASSET__C1MFKm32__"